import _default from "keen-slider";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks
    } = window.wp.editor;

    const ALLOWED_BLOCKS = ['custom-gutenberg/hero-slide'];

    registerBlockType('custom-gutenberg/hero-slider', {
        // built-in attributes
        title: 'Hero Slider',
        description: 'Custom Hero Slider',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // built-in functions
        edit() {

            const MY_TEMPLATE = [
                [ 'custom-gutenberg/hero-slide', {} ],
            ];

            return (
                <div class="home-hero position-relative">
                    <div id="hero-slider" class="keen-slider" style={ { opacity: '1' } }>
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } />
                    </div>
                    <div class="keen-slider__pager">
                        <div class="keen-slider__pager-buttons"></div>
                    </div>
                </div>
            );
        },

        save() {
            return (
                <div className="home-hero position-relative" >
                    <div id="hero-slider" className="keen-slider">
                        <InnerBlocks.Content />
                    </div>
                    <div className="keen-slider__pager">
                        <div className="keen-slider__pager-buttons"></div>
                    </div>
                    <div className="keen-slider__arrows container-fluid">
                            <div ref="" data-dir="prev"><i className="las la-angle-double-left"></i></div>
                            <div ref="" data-dir="next"><i className="las la-angle-double-right"></i></div>
                        </div>
                </div>
            );
        },
    });
}